import { DesignPermission, DesignPermissionGroup } from '../types';

type PermissionGroup = {
  accessLevel: number;
  defaultValue: DesignPermission;
  name: string;
};

export const userGroup: Record<DesignPermissionGroup, PermissionGroup> = {
  admin: {
    name: 'Admin',
    accessLevel: 100,
    defaultValue: {
      read: true,
      write: true
    }
  },
  manager: {
    name: 'Manager',
    accessLevel: 75,
    defaultValue: {
      read: true,
      write: true
    }
  },
  developer: {
    name: 'Developer',
    accessLevel: 50,
    defaultValue: {
      read: true,
      write: true
    }
  },
  marketing: {
    name: 'Marketing',
    accessLevel: 25,
    defaultValue: {
      read: true,
      write: false
    }
  }
};
